export default __webpack_public_path__ + "static/media/booking_agent.e2a798e7.jpg";